import { useCallback } from 'react';
import { useAddChatroomMessageToCache } from '#features/chatrooms';
import type { MessageDataObject } from '#models/services';

type UseHandleSocketChatroomMessageParams = {
  currentUserId: string;
};

export const useHandleSocketChatroomMessage = ({ currentUserId }: UseHandleSocketChatroomMessageParams) => {
  const addChatroomMessageToCache = useAddChatroomMessageToCache();

  return useCallback(
    (socketData: MessageDataObject) => {
      if (socketData.author !== currentUserId) {
        addChatroomMessageToCache({ chatroomId: socketData.chatroom, message: socketData });
      }
    },
    [currentUserId, addChatroomMessageToCache],
  );
};
